<template>
  <div class="header">
    <div class="header-cont">
      <div
        class="header-logo"
        @click="handleClickLogo"
      ></div>
      <div class="header-nav">
        <div
          class="nav-left"
          @click="handleOperatorPlatform"
        >
          知识产权交易平台
        </div>
        <div
          v-if="hasUserInfo"
          class="nav-right"
        >
          <div class="nav-right-user">
            <div>
              <el-dropdown
                placement="bottom-end"
                class="user-drop"
                :hide-on-click="hideOnClick"
                @command="handleCommand"
              >
                <span class="el-dropdown-link">
                  <img
                    class="avatar"
                    :src="getUserAvatar(userIdentity.avatar)"
                    alt=""
                  />
                  <span class="username">{{ userIdentity.userName }}</span>
                  <img
                    class="more"
                    src="@/assets/images/home/icon-more-arrow.png"
                    alt=""
                  />
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(item,index) in personDropDownList"
                    :key="index"
                    :command="item.jumpUrl"
                  >
                    <template v-if="item.jumpUrl && item.jumpUrl !=''">
                      <img
                        class="drop-icon"
                        :src="item.iconImg"
                        alt=""
                      /> {{ item.name }}
                    </template>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
        <div
          v-else
          class="nav-right"
        >
          <el-button
            class="signBtn"
            type="primary"
            size="small"
            @click="toSign"
          >
            登录
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const ENV_MAP = new Map([
  ['apre-www.ipjy365.com', 'https://apre-www.quandashi.com'],
  ['www.ipjy365.com', 'https://www.quandashi.com']
]);

import { mapState } from 'vuex';
import { logout } from "@/apis/userCenter/userCenter";
import base from '@/utils/js/base';
import * as type from '@/store/mutation-types';
export default {
  data() {
    return {
      imgPrefix: 'https://files.quandashi.com',
      personDropDownList: [
        {
          name: '退出登录',
          iconImg: require('@/assets/images/home/icon-tcdl.png'),
          jumpUrl: '/index/logout'
        }
      ],
      hideOnClick: false,
    }
  },
  computed: {
    ...mapState('userInfo', {
      hasUserInfo: state => state.hasLoginInfo,
      userInfo: state => state.QDS_LOGIN_INFO_OFFICE,
    }),
    ...mapState('common', {
      userIdentity: state => state.userIdentity
    }),
  },
  watch: {
    
  },
  mounted(){
    
  },
  methods: {
    getUserAvatar(url) {
      if (!url) {
        return require('@/assets/images/home/avatar.png');
      }
      if (url[0] == '/') {
        return this.imgPrefix + url;
      }
      return this.imgPrefix + '/' + url;
    },
    getUserImg(url) {
      if (url.indexOf('http' > -1)) {
        return url;
      } else if (url[0] == '/') {
        return this.imgPrefix + url;
      }
      return this.imgPrefix + '/' +url;
    },
    handleCommand(command){
      if (!command) return;
      if(command=='/index/logout'){
        this.logout();
      } else {
        this.$router.push(command);
      }
    },
    logout(){
      var that = this;
      let params = {
        appKey: 'quandashi4106565062',
        signMethod: 'md5',
        inputType: 1,
        v: '1.0',
        executor: "140fcf1dfb9b6368d33e1d16d14fcad3",
        inputType: 1,
        format: 'json',
        timestamp: new Date().getTime(),
        sign: new Date().getTime(),
      }
      logout(params).then(res=>{
        that.$toast.showToast('退出成功')
        that.$nextTick(()=>{
          localStorage.removeItem('wxzcTokenValue');
          localStorage.removeItem('wxzcTokenName');
          localStorage.removeItem('userId');
          localStorage.removeItem('QDS_LOGIN_INFO_OFFICE_'+document.domain);
          localStorage.removeItem('QDS_AGENT_ORGAN_INFO_'+document.domain);
          let info = {
            agentOrWriter: '',
            operatorId: "",
            operatorName: "",
            userId: "",
            userImg: "",
            userName: ""
          }
          that.$store.commit('userInfo/setHasLoginInfo', false);
          that.$store.commit('userInfo/setLoginInfoOffice', info);
          that.$store.commit('userInfo/setPartnerType', '');
          that.$store.commit('userInfo/setAgentType', '');
          that.$store.commit('userInfo/setAgentType', '');
          let clearUserIdentity = {
            agentType: 0,
            avatar: '',
            userName: '',
            userType: 0
          };
          that.$store.commit(`common/${type.SET_USER_IDENTITY}`, clearUserIdentity);
          base.clearCookie('QDS_LOGIN_INFO_OFFICE_'+document.domain);
          base.clearCookie('QDS_AGENT_ORGAN_INFO_'+document.domain);
          base.clearCookie('QDS_COOKIE_'+document.domain);
          if(window.location.href.indexOf('homePage') > -1){
            this.$router.go(0);
          } else {
            this.$router.push('/homePage')
          }
        })
      })
    },
    // 登录
    toSign(){
      sessionStorage.setItem('qdsHistoryRoutePath',this.$router.history.current.path)
      sessionStorage.setItem('qdsHistoryRouteQuery',this.$router.history.current.query.userIdStr?'{}':JSON.stringify(this.$router.history.current.query))
      this.$router.push({path: '/login'});
    },
    // logo 点击
    handleClickLogo() {
      if (this.$route.path == '/homePage' || this.$route.path == '/') {
        this.$router.go(0);
      } else {
        this.$router.push('/homePage');
      }
    },
    // 工作台点击
    handleOperatorPlatform() {
      if (this.$route.path == '/homePage' || this.$route.path == '/') {
        this.$router.go(0);
      } else {
        this.$router.push('/homePage');
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  ::v-deep .el-dropdown-menu__item{
    padding-right: 50px;
    &:not(.is-disabled):hover {
      background-color: #ecf5ff;
      color: #606266;
    }
    .drop-icon{
      width: 20px;
      margin-right: 14px;
      vertical-align: middle;
    }
  }
  .header {
    width: 100%;
    height: 60px;
    background-color: #fff;
    border-bottom: solid 1px rgba(113, 114, 119, 0.2);
    box-shadow: 0px 0px 6px 0px rgba(11, 17, 60, 0.1);
    .header-cont {
      display: flex;
      flex-direction: row;
      width: 1280px;
      height: 100%;
      margin: 0 auto;
      .header-logo {
        width: 75px;
        height: 100%;
        color: $color-text;
        background: url('../../../assets/images/home/img-logo-top.png') no-repeat center;
        text-align: center;
        cursor: pointer;
      }
      .header-nav {
        flex: 1;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        .nav-left {
          cursor: pointer;
          // margin-left: 40px;
          height: 60px;
          text-align: center;
          line-height: 60px;
          font-weight: bold;
          font-size: $font-size-large-x;
          color: #222;
        }
        .nav-right {
          position: relative;
          height: 60px;
          margin-right: 4px;
          padding-top: 14px;
          box-sizing: border-box;
          .nav-right-bell {
            display: inline-block;
            width: 24px;
            height: 29px;
            position: relative;
            cursor: pointer;
            img{
              width: 24px;
              height: 29px;
            }
            .badgeItem{
              ::v-deep .el-badge__content{
                background-color: #e90027;
                border-radius: 50%;
                width: 22px;
                height: 22px;
                line-height: 22px;
                padding: 0;
                border: none;
              }
            }
          }
          .nav-right-user{
            margin-left: 30px;
            display: inline-block;
            position: relative;
            cursor: pointer;
            .avatar{
              width: 25px;
              height: 25px;
              border-radius: 50%;
            }
            .username{
              position: relative;
              top: -8px;
              margin-left: 5px;
              color: #666;
              font-size: 14px;
            }
            .more{
              width: 6px;
              margin-left: 2px;
            }
          }
          .signBtn{
            border: 1px solid #ff7200;
            color: #ffffff;
            background: #ff7200;
          }
          .registerBtn{
            color: #ffffff;
            background: #ff7200;
            border-color: #ff7200;
          }
          .nav-right-tip {
            position: absolute;
            left: 3px;
            top: 60px;
            padding: 2px 5px;
            width: 170px;
            font-size: 12px;
            color: #fff;
            background-color: #000;
            white-space: normal;
            border-radius: 8px;
          }
          .nav-right-tip::before {
            position: absolute;
            top: -20px;
            left: 51px;
            content: "";
            width: 0;
            height: 0;
            border: 10px solid transparent;
            border-bottom-color: #000;
          }
        }
      }
    }
  }
</style>